__turbopack_context__.v({
  "checked": "Switch-module-scss-module__jwcUwW__checked",
  "disabled": "Switch-module-scss-module__jwcUwW__disabled",
  "root": "Switch-module-scss-module__jwcUwW__root",
  "switchBase": "Switch-module-scss-module__jwcUwW__switchBase",
  "thumb": "Switch-module-scss-module__jwcUwW__thumb",
  "track": "Switch-module-scss-module__jwcUwW__track",
});
